import hasStorage from './hasStorage';
import isDebugMode from './isDebugMode';
import initSetVisitorIdForGoogleRetail from './setVisitorIdForGoogleRetail';


window.RVN = window.RVN || {};

function staticConfigs() {
  const formatData = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  const scripts = document.body.querySelectorAll('script[type="application/json"]');
  const configs = {};

  scripts.forEach((config) => {
    const data = config.innerHTML;
    const name = Object.keys(config.dataset)[0];
    const active = config.dataset[name] === 'true';
    let dataConfig = {};

    if (!formatData.test(data) || !active) return;

    try {
      dataConfig = JSON.parse(data.replace(formatData, ''));
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
    }

    configs[name] = dataConfig;
  });

  return configs;
}

function configureGlobals() {
  window.RVN = {
    ...window.RVN,
    ...staticConfigs(),
    hasStorage,
    isDebugMode,
  };
  initSetVisitorIdForGoogleRetail();
}

export default configureGlobals;
